import type { TcValidation } from '@/store/types.ts';
import type { TradeCaptureResponseFieldError } from '@/types/trade-capture.ts';

export function getTcValidation(
  errors: TradeCaptureResponseFieldError[] | undefined,
  warnings: TradeCaptureResponseFieldError[] | undefined,
) {
  const tcValidations = [
    ...(errors?.map((v) => mapToValidation(v, 'error')) ?? []),
    ...(warnings?.map((v) => mapToValidation(v, 'warning')) ?? []),
  ];
  if (tcValidations.length === 0) {
    return undefined;
  }

  return tcValidations;
}

function mapToValidation(tcError: TradeCaptureResponseFieldError, type: 'warning' | 'error'): TcValidation {
  return { ...tcError, type };
}

export function getPreviousValue(validationField: TcValidation[] | undefined) {
  return validationField?.[0]?.previousValue;
}
